import { render, staticRenderFns } from "./review-text.vue?vue&type=template&id=30298a52"
import script from "./review-text.vue?vue&type=script&lang=ts"
export * from "./review-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports